export default __webpack_public_path__ + "static/media/card-envelope.f0db6ee3.jpg";